import React from 'react';
import { Col, Button } from 'react-bootstrap';
import CommandButton from './CommandButton';

const CalibrationSection = ({
  loading,
  comandos,
  retConfig,
  cmdToConfigMap,
  commandFeedback,
  calibrationCommands,
  criticalCommands,
  getButtonLabel,
  handleCmdChange,
  handleDialCapxModalOpen,
  handleDialCapx2ModalOpen,
  pendingChanges,
  getPendingCalibrationCount,
  disabled = false
}) => {
  const getButtonColor = (cmd, hasPending = false) => {
    // Se há alteração pendente, usa cor especial (laranja)
    if (hasPending) return '#f59e0b';
    if (calibrationCommands.includes(cmd.cmd)) return 'var(--brand-light-green, #8fad15)';
    if (cmd.params === 0) return 'var(--secondary-color, #6c757d)';
    if (criticalCommands.includes(cmd.cmd)) return 'var(--danger-color, #dc3545)';
    return 'var(--primary-color, #0d6efd)';
  };

  return (
    <>
      {/* Coluna esquerda: Calibração DIAL1/CAPX1, Calibração Curva 1 (CHART1) e Range Umidade 1 (UMIRAN1) */}
      <Col xs={12} md={6} className="mb-2">
        <Button
          className="w-100 py-2 mb-2"
          disabled={loading || disabled}
          onClick={handleDialCapxModalOpen}
          style={{
            fontWeight: 600,
            letterSpacing: 0.5,
            fontSize: '0.9rem',
            whiteSpace: 'pre-line',
            minHeight: '50px',
            backgroundColor: getPendingCalibrationCount('CALDIAL1') > 0 || getPendingCalibrationCount('CALCAPX1') > 0 ? '#f59e0b' : 'var(--brand-light-green, #8fad15)',
            color: '#fff',
            border: 'none'
          }}
        >
          {getPendingCalibrationCount('CALDIAL1') > 0 || getPendingCalibrationCount('CALCAPX1') > 0 ? (
            <>
              Calibração (DIAL1 / CAPX1)
              <br />
              <small style={{ fontSize: '0.8rem', opacity: 0.9 }}>
                [{getPendingCalibrationCount('CALDIAL1') + getPendingCalibrationCount('CALCAPX1')} alterações pendentes]
              </small>
            </>
          ) : (
            'Calibração (DIAL1 / CAPX1)'
          )}
        </Button>

        {/* Botão Calibração Curva 1 (CHART1) */}
        {(() => {
          const chart1Cmd = comandos.find(c => c.cmd === 'CHART1');
          if (!chart1Cmd) return null;

          const configKey = cmdToConfigMap[chart1Cmd.cmd];
          const hasValue = retConfig && configKey && retConfig[configKey] !== undefined;
          const isCalibration = calibrationCommands.includes(chart1Cmd.cmd);
          const feedback = commandFeedback[chart1Cmd.cmd];
          const pendingCount = getPendingCalibrationCount('CHART1');
          const hasPending = pendingCount > 0;

          return (
            <CommandButton
              cmdObj={chart1Cmd}
              loading={loading}
              disabled={disabled}
              onClick={() => handleCmdChange(chart1Cmd)}
              getButtonLabel={() => hasPending ? `${chart1Cmd.label}\n[${pendingCount} alterações pendentes]` : getButtonLabel(chart1Cmd)}
              getButtonColor={() => getButtonColor(chart1Cmd, hasPending)}
              hasValue={hasValue}
              feedback={feedback}
              isCalibration={isCalibration}
              criticalCommands={criticalCommands}
            />
          );
        })()}

        {/* Botão Range Umidade 1 (UMIRAN1) */}
        {(() => {
          const umiran1Cmd = comandos.find(c => c.cmd === 'UMIRAN1');
          if (!umiran1Cmd) return null;

          const configKey = cmdToConfigMap[umiran1Cmd.cmd];
          const hasValue = retConfig && configKey && retConfig[configKey] !== undefined;
          const isCalibration = calibrationCommands.includes(umiran1Cmd.cmd);
          const feedback = commandFeedback[umiran1Cmd.cmd];
          const hasPending = pendingChanges['UMIRAN1'];

          return (
            <CommandButton
              cmdObj={umiran1Cmd}
              loading={loading}
              disabled={disabled}
              onClick={() => handleCmdChange(umiran1Cmd)}
              getButtonLabel={() => getButtonLabel(umiran1Cmd)}
              getButtonColor={() => getButtonColor(umiran1Cmd, hasPending)}
              hasValue={hasValue}
              feedback={feedback}
              isCalibration={isCalibration}
              criticalCommands={criticalCommands}
              className="w-100 py-2"
            />
          );
        })()}
      </Col>

      {/* Coluna direita: Calibração DIAL2/CAPX2, Calibração Curva 2 (CHART2) e Range Umidade 2 (UMIRAN2) */}
      <Col xs={12} md={6} className="mb-2">
        <Button
          className="w-100 py-2 mb-2"
          disabled={loading || disabled}
          onClick={handleDialCapx2ModalOpen}
          style={{
            fontWeight: 600,
            letterSpacing: 0.5,
            fontSize: '0.9rem',
            whiteSpace: 'pre-line',
            minHeight: '50px',
            backgroundColor: getPendingCalibrationCount('CALDIAL2') > 0 || getPendingCalibrationCount('CALCAPX2') > 0 ? '#f59e0b' : 'var(--brand-light-green, #8fad15)',
            color: '#fff',
            border: 'none'
          }}
        >
          {getPendingCalibrationCount('CALDIAL2') > 0 || getPendingCalibrationCount('CALCAPX2') > 0 ? (
            <>
              Calibração (DIAL2 / CAPX2)
              <br />
              <small style={{ fontSize: '0.8rem', opacity: 0.9 }}>
                [{getPendingCalibrationCount('CALDIAL2') + getPendingCalibrationCount('CALCAPX2')} alterações pendentes]
              </small>
            </>
          ) : (
            'Calibração (DIAL2 / CAPX2)'
          )}
        </Button>

        {/* Botão Calibração Curva 2 (CHART2) */}
        {(() => {
          const chart2Cmd = comandos.find(c => c.cmd === 'CHART2');
          if (!chart2Cmd) return null;

          const configKey = cmdToConfigMap[chart2Cmd.cmd];
          const hasValue = retConfig && configKey && retConfig[configKey] !== undefined;
          const isCalibration = calibrationCommands.includes(chart2Cmd.cmd);
          const feedback = commandFeedback[chart2Cmd.cmd];
          const pendingCount = getPendingCalibrationCount('CHART2');
          const hasPending = pendingCount > 0;

          return (
            <CommandButton
              cmdObj={chart2Cmd}
              loading={loading}
              disabled={disabled}
              onClick={() => handleCmdChange(chart2Cmd)}
              getButtonLabel={() => hasPending ? `${chart2Cmd.label}\n[${pendingCount} alterações pendentes]` : getButtonLabel(chart2Cmd)}
              getButtonColor={() => getButtonColor(chart2Cmd, hasPending)}
              hasValue={hasValue}
              feedback={feedback}
              isCalibration={isCalibration}
              criticalCommands={criticalCommands}
            />
          );
        })()}

        {/* Botão Range Umidade 2 (UMIRAN2) */}
        {(() => {
          const umiran2Cmd = comandos.find(c => c.cmd === 'UMIRAN2');
          if (!umiran2Cmd) return null;

          const configKey = cmdToConfigMap[umiran2Cmd.cmd];
          const hasValue = retConfig && configKey && retConfig[configKey] !== undefined;
          const isCalibration = calibrationCommands.includes(umiran2Cmd.cmd);
          const feedback = commandFeedback[umiran2Cmd.cmd];
          const hasPending = pendingChanges['UMIRAN2'];

          return (
            <CommandButton
              cmdObj={umiran2Cmd}
              loading={loading}
              disabled={disabled}
              onClick={() => handleCmdChange(umiran2Cmd)}
              getButtonLabel={() => getButtonLabel(umiran2Cmd)}
              getButtonColor={() => getButtonColor(umiran2Cmd, hasPending)}
              hasValue={hasValue}
              feedback={feedback}
              isCalibration={isCalibration}
              criticalCommands={criticalCommands}
              className="w-100 py-2"
            />
          );
        })()}
      </Col>
    </>
  );
};

export default CalibrationSection;
